import { useState } from "react";
import { motion } from "framer-motion";
import { MapPin, Clock, Download, CalendarDays } from "lucide-react";

const PDF_URL =
  "https://customer-assets-7cd3h4nn.emergentagent.net/job_adult-baseball-hub/artifacts/jum1w41i_WABL%20Schedule%20w_%20Playoffs.pdf";

const SCHEDULE = [
  {
    label: "Week 1", sub: "Sep 5 – 6",
    games: [
      { date: "Sat, Sep 5", time: "1:00 PM", away: "Dinwiddie Dream Team", home: "Dinwiddie County Boys", field: "Dinwiddie High School" },
      { date: "Sat, Sep 5", time: "4:30 PM", away: "Virginia Aces", home: "Dinwiddie Dream Team", field: "Dinwiddie High School" },
      { date: "Sat, Sep 5", time: "5:00 PM", away: "River City All Stars", home: "Prince George Originals", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Sep 6", time: "12:00 PM", away: "Virginia Minutemen", home: "Tri-City Sluggers", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Sep 6", time: "3:30 PM", away: "Brunswick Bat Boys", home: "Dinwiddie Brew Crew", field: "Dinwiddie Sports Complex" },
    ],
  },
  {
    label: "Week 2", sub: "Sep 12 – 13",
    games: [
      { date: "Sat, Sep 12", time: "2:00 PM", away: "River City All Stars", home: "Tri-City Sluggers", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Sep 12", time: "5:30 PM", away: "Virginia Aces", home: "Dinwiddie Brew Crew", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Sep 13", time: "12:00 PM", away: "Virginia Minutemen", home: "Brunswick Bat Boys", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Sep 13", time: "12:00 PM", away: "Dinwiddie County Boys", home: "Dinwiddie Dream Team", field: "Dinwiddie High School" },
      { date: "Sun, Sep 13", time: "3:30 PM", away: "Dinwiddie County Boys", home: "Prince George Originals", field: "Dinwiddie High School" },
    ],
  },
  {
    label: "Week 3", sub: "Sep 19 – 20",
    games: [
      { date: "Sat, Sep 19", time: "2:00 PM", away: "Prince George Originals", home: "Tri-City Sluggers", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Sep 19", time: "5:30 PM", away: "Tri-City Sluggers", home: "Dinwiddie Dream Team", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Sep 19", time: "5:30 PM", away: "Virginia Aces", home: "Virginia Minutemen", field: "Petersburg Sports Complex" },
      { date: "Sun, Sep 20", time: "12:00 PM", away: "Dinwiddie County Boys", home: "Dinwiddie Brew Crew", field: "Dinwiddie High School" },
      { date: "Sun, Sep 20", time: "12:00 PM", away: "River City All Stars", home: "Brunswick Bat Boys", field: "Petersburg Sports Complex" },
    ],
  },
  {
    label: "Week 4", sub: "Sep 26 – 27",
    games: [
      { date: "Sat, Sep 26", time: "2:00 PM", away: "Dinwiddie Brew Crew", home: "Prince George Originals", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Sep 26", time: "4:00 PM", away: "Dinwiddie County Boys", home: "Virginia Minutemen", field: "Dinwiddie High School" },
      { date: "Sat, Sep 26", time: "5:30 PM", away: "Prince George Originals", home: "Brunswick Bat Boys", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Sep 27", time: "12:00 PM", away: "Virginia Aces", home: "River City All Stars", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Sep 27", time: "3:30 PM", away: "Tri-City Sluggers", home: "Dinwiddie Dream Team", field: "Dinwiddie Sports Complex" },
    ],
  },
  {
    label: "Week 5", sub: "Oct 3 – 4",
    games: [
      { date: "Sat, Oct 3", time: "2:00 PM", away: "Prince George Originals", home: "Virginia Aces", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Oct 3", time: "2:00 PM", away: "Dinwiddie County Boys", home: "River City All Stars", field: "Dinwiddie High School" },
      { date: "Sat, Oct 3", time: "5:30 PM", away: "Dinwiddie Dream Team", home: "Dinwiddie Brew Crew", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Oct 4", time: "12:00 PM", away: "Tri-City Sluggers", home: "Brunswick Bat Boys", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Oct 4", time: "3:30 PM", away: "Virginia Minutemen", home: "Brunswick Bat Boys", field: "Dinwiddie Sports Complex" },
    ],
  },
  {
    label: "Week 6", sub: "Oct 10 – 11",
    games: [
      { date: "Sat, Oct 10", time: "2:00 PM", away: "Brunswick Bat Boys", home: "Dinwiddie Dream Team", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Oct 10", time: "4:00 PM", away: "Prince George Originals", home: "Dinwiddie County Boys", field: "Dinwiddie High School" },
      { date: "Sat, Oct 10", time: "5:30 PM", away: "Dinwiddie Brew Crew", home: "Virginia Minutemen", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Oct 11", time: "12:00 PM", away: "Tri-City Sluggers", home: "Virginia Aces", field: "Petersburg Sports Complex" },
      { date: "Sun, Oct 11", time: "3:30 PM", away: "River City All Stars", home: "Virginia Aces", field: "Petersburg Sports Complex" },
    ],
  },
  {
    label: "Week 7", sub: "Oct 17 – 18",
    games: [
      { date: "Sat, Oct 17", time: "11:00 AM", away: "Dinwiddie Brew Crew", home: "River City All Stars", field: "Dinwiddie High School" },
      { date: "Sat, Oct 17", time: "2:30 PM", away: "Prince George Originals", home: "River City All Stars", field: "Dinwiddie High School" },
      { date: "Sat, Oct 17", time: "6:00 PM", away: "Tri-City Sluggers", home: "Dinwiddie County Boys", field: "Dinwiddie High School" },
      { date: "Sun, Oct 18", time: "12:00 PM", away: "Dinwiddie Dream Team", home: "Virginia Minutemen", field: "Dinwiddie High School" },
      { date: "Sun, Oct 18", time: "3:30 PM", away: "Brunswick Bat Boys", home: "Virginia Aces", field: "Dinwiddie High School" },
    ],
  },
  {
    label: "Week 8", sub: "Oct 24",
    games: [
      { date: "Sat, Oct 24", time: "2:00 PM", away: "Virginia Minutemen", home: "Tri-City Sluggers", field: "Dinwiddie Sports Complex" },
      { date: "Sat, Oct 24", time: "2:00 PM", away: "Dinwiddie Dream Team", home: "Virginia Aces", field: "Dinwiddie High School" },
      { date: "Sat, Oct 24", time: "5:30 PM", away: "Brunswick Bat Boys", home: "Dinwiddie County Boys", field: "Dinwiddie High School" },
      { date: "Sat, Oct 24", time: "5:30 PM", away: "River City All Stars", home: "Virginia Minutemen", field: "Petersburg Sports Complex" },
      { date: "Sat, Oct 24", time: "5:30 PM", away: "Dinwiddie Brew Crew", home: "Prince George Originals", field: "Dinwiddie Sports Complex" },
    ],
  },
  {
    label: "Week 9", sub: "Oct 31 – Nov 1",
    games: [
      { date: "Sat, Oct 31", time: "2:00 PM", away: "Virginia Aces", home: "Dinwiddie County Boys", field: "Dinwiddie High School" },
      { date: "Sat, Oct 31", time: "2:00 PM", away: "Virginia Minutemen", home: "Prince George Originals", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Nov 1", time: "12:00 PM", away: "Dinwiddie Brew Crew", home: "Tri-City Sluggers", field: "Petersburg Sports Complex" },
      { date: "Sun, Nov 1", time: "12:00 PM", away: "Dinwiddie Dream Team", home: "River City All Stars", field: "Dinwiddie Sports Complex" },
      { date: "Sun, Nov 1", time: "3:30 PM", away: "Brunswick Bat Boys", home: "Dinwiddie Brew Crew", field: "Petersburg Sports Complex" },
    ],
  },
  {
    label: "Makeup", sub: "Nov 7 – 8",
    games: [
      { date: "Sat, Nov 7", time: "TBD", away: "Regular-season makeup games", home: "Rainouts", field: "Petersburg & Dinwiddie Sports Complexes" },
      { date: "Sun, Nov 8", time: "TBD", away: "Regular-season makeup games", home: "Rainouts", field: "Petersburg & Dinwiddie Sports Complexes" },
    ],
  },
  {
    label: "Quarterfinals", sub: "Nov 14 · Playoffs", playoff: true,
    games: [
      { date: "Sat, Nov 14", time: "10:00 AM", away: "#9 Seed", home: "#8 Seed", field: "Petersburg Sports Complex", note: "Play-In Game" },
      { date: "Sat, Nov 14", time: "1:30 PM", away: "Winner #8/#9", home: "#1 Seed", field: "Petersburg Sports Complex", note: "Quarterfinal" },
      { date: "Sat, Nov 14", time: "2:00 PM", away: "#6 Seed", home: "#3 Seed", field: "Dinwiddie Sports Complex", note: "Quarterfinal" },
      { date: "Sat, Nov 14", time: "5:00 PM", away: "#5 Seed", home: "#4 Seed", field: "Petersburg Sports Complex", note: "Quarterfinal" },
      { date: "Sat, Nov 14", time: "5:00 PM", away: "#7 Seed", home: "#2 Seed", field: "Dinwiddie Sports Complex", note: "Quarterfinal" },
    ],
  },
  {
    label: "Semifinals", sub: "Nov 21 · Playoffs", playoff: true,
    games: [
      { date: "Sat, Nov 21", time: "1:00 PM", away: "Lowest Remaining Seed", home: "Highest Remaining Seed", field: "Petersburg Sports Complex", note: "Semifinal" },
      { date: "Sat, Nov 21", time: "4:00 PM", away: "Other Two Remaining Teams", home: "", field: "Petersburg Sports Complex", note: "Semifinal" },
    ],
  },
  {
    label: "Championship", sub: "Nov 28 – 29 · Finals", playoff: true,
    games: [
      { date: "Sat, Nov 28", time: "4:00 PM", away: "Championship Series", home: "Game 1", field: "Petersburg Sports Complex", note: "Finals" },
      { date: "Sun, Nov 29", time: "12:00 PM", away: "Championship Series", home: "Game 2", field: "Petersburg Sports Complex", note: "Finals" },
      { date: "Sun, Nov 29", time: "3:00 PM", away: "Championship Series", home: "Game 3", field: "Petersburg Sports Complex", note: "If necessary" },
    ],
  },
];

const GameRow = ({ g, playoff }) => (
  <div className="grid grid-cols-1 sm:grid-cols-12 gap-2 sm:gap-4 items-center py-4 border-b border-white/5 last:border-b-0">
    <div className="sm:col-span-2 flex items-center gap-2 text-[#F4A261]">
      <Clock size={14} className="shrink-0" />
      <span className="text-sm font-bold uppercase tracking-wide">{g.time}</span>
    </div>
    <div className="sm:col-span-6">
      <p className="font-bold text-base sm:text-lg leading-tight">
        <span className="text-[#C7CDD4]">{g.away}</span>
        {g.home && <span className="text-[#FF3B30] font-heading px-2 text-sm">@</span>}
        {g.home && <span className="text-white">{g.home}</span>}
      </p>
      {g.note && <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#8A94A0]">{g.note}</span>}
    </div>
    <div className="sm:col-span-4 flex items-center gap-2 text-[#8A94A0]">
      <MapPin size={14} className="shrink-0" />
      <span className="text-sm font-medium">{g.field}</span>
    </div>
  </div>
);

export const Schedule = () => {
  const [active, setActive] = useState(0);
  const week = SCHEDULE[active];

  // group games by date
  const byDate = week.games.reduce((acc, g) => {
    (acc[g.date] = acc[g.date] || []).push(g);
    return acc;
  }, {});

  return (
    <section id="schedule" data-testid="schedule-section" className="relative py-24 lg:py-32 bg-[#0A0A0A] border-t border-white/10">
      <div className="max-w-6xl mx-auto px-6 lg:px-10">
        <div className="flex flex-col md:flex-row md:items-end md:justify-between gap-6">
          <div>
            <span className="text-[#FF3B30] text-xs font-bold uppercase tracking-[0.3em]">2026 Season</span>
            <h2 className="text-4xl sm:text-5xl uppercase tracking-tighter mt-4 leading-[0.95]">
              Schedule &amp; Playoffs
            </h2>
            <p className="mt-6 text-[#8A94A0] text-lg font-medium max-w-xl">
              Every game, weekend by weekend. Home team listed second.
            </p>
          </div>
          <a
            href={PDF_URL}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="download-schedule-pdf"
            className="inline-flex items-center gap-2 font-heading uppercase tracking-wide border border-white/20 hover:border-[#FF3B30] hover:text-[#FF3B30] transition-colors px-6 py-3 self-start"
          >
            <Download size={18} /> Full PDF
          </a>
        </div>

        {/* Week selector */}
        <div className="mt-10 flex gap-2 overflow-x-auto pb-2 -mx-1 px-1" data-testid="week-selector">
          {SCHEDULE.map((w, i) => (
            <button
              key={w.label}
              data-testid={`week-tab-${i}`}
              onClick={() => setActive(i)}
              className={`shrink-0 px-4 py-3 text-xs font-bold uppercase tracking-[0.15em] border transition-all ${
                active === i
                  ? w.playoff ? "bg-[#F4A261] text-[#0A0A0A] border-[#F4A261]" : "bg-[#FF3B30] text-white border-[#FF3B30]"
                  : "border-white/15 text-[#8A94A0] hover:border-white/40"
              }`}
            >
              {w.label}
            </button>
          ))}
        </div>

        {/* Games */}
        <motion.div
          key={active}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4 }}
          className="mt-8 border border-white/10 bg-[#141414]"
          data-testid="schedule-week-panel"
        >
          <div className={`px-6 py-4 flex items-center gap-3 border-b border-white/10 ${week.playoff ? "bg-[#F4A261]/10" : ""}`}>
            <CalendarDays size={20} className={week.playoff ? "text-[#F4A261]" : "text-[#FF3B30]"} />
            <h3 className="text-xl uppercase tracking-tight">{week.label}</h3>
            <span className="text-xs font-bold uppercase tracking-[0.2em] text-[#8A94A0]">{week.sub}</span>
          </div>
          <div className="p-6">
            {Object.entries(byDate).map(([date, games]) => (
              <div key={date} className="mb-6 last:mb-0">
                <p className="font-heading text-sm uppercase tracking-[0.2em] text-white/40 mb-2">{date}</p>
                {games.map((g, idx) => <GameRow key={idx} g={g} playoff={week.playoff} />)}
              </div>
            ))}
          </div>
        </motion.div>
      </div>
    </section>
  );
};
